import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { CrudType } from "@core/enums/crud-type";
import { DividendHelper } from "@core/helpers/dividend-helper";
import { Dividend } from "@core/models/dividend-model";
import { TableSorting } from "@custom-types/sorting";
import { environment } from "@env/environment";
import { SortingParams } from "@features/+shared/sorting-params/sorting-params";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class DividendService {
  constructor(private http: HttpClient) {}

  getDividends$(
    searchTerm?: string,
    sorting?: TableSorting
  ): Observable<Array<Dividend>> {
    let params = SortingParams.appendParams(sorting);

    if (searchTerm) {
      params = params.append("searchTerm", searchTerm);
    }

    return this.http
      .get<Array<Dividend>>(`${environment.BASE_URL}dividend/`, { params })
      .pipe(
        map(
          (
            response: { data?: Array<Dividend> } | Array<Dividend>
          ): Array<Dividend> => {
            return Array.isArray(response) ? response : response.data || [];
          }
        )
      );
  }

  saveDividend$(
    dividend: Partial<Dividend>,
    id: string | undefined
  ): Observable<unknown> {
    const create = id === "" || id === undefined;
    DividendHelper.convertDates(dividend);
    return this.http[create ? CrudType.Post : CrudType.Put](
      `${environment.BASE_URL}dividend/${!create ? `${id}` : ""}`,
      dividend
    );
  }

  generateRecordAssignments$(dividendId: string): Observable<unknown> {
    return this.http.post(
      `${environment.BASE_URL}dividend/${dividendId}/generateassignments`,
      {}
    );
  }

  postDividendResults$(dividendId: string): Observable<unknown> {
    return this.http.post(
      `${environment.BASE_URL}dividend/${dividendId}/postdividendresult`,
      {}
    );
  }
}
